import { Pipe } from '@angular/core';
import { isNumberFinite } from '../utils/utils';
var PowPipe = (function () {
    function PowPipe() {
    }
    PowPipe.prototype.transform = function (input, power) {
        if (power === void 0) { power = 2; }
        if (!isNumberFinite(input)) {
            return 'NaN';
        }
        return Math.pow(input, power);
    };
    return PowPipe;
}());
export { PowPipe };
PowPipe.decorators = [
    { type: Pipe, args: [{
                name: 'pow'
            },] },
];
/** @nocollapse */
PowPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=pow.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/pow.pipe.js
// module id = 264
// module chunks = 103